import React from 'react';
import { formatToDateTimeFormaterTemplate } from '@/common/functions/dateFormater';
import { Colors } from '@/common/colors/colors';
import { IconsWrapper } from '@/pages/admin/test/styles/Test.styles';
import ActionButton from '@/common/components/buttons/ActionButton';
import Icon from '@/common/components/Icon';

const CurrentWeekScoreTable = ({
	data,
	handleGetRecording,
	handleGeToRate,
	setShowTicket,
	handleGetTranscription,
}) => {
	return (
		<table className='styled-table'>
			<thead>
				<tr>
					<th>No.</th>
					<th>Consultant</th>
					<th>Type</th>
					<th>Product</th>
					<th>Calling start at</th>
					<th>Number</th>
					<th>Client Full name</th>
					<th>Recording</th>
				</tr>
			</thead>
			<tbody className='queue'>
				{data
					?.sort(
						(a, b) =>
							new Date(b.created_at).getTime() -
							new Date(a.created_at).getTime(),
					)
					.map((elemnet, i) => (
						<tr>
							<td>{i + 1}</td>
							<td>{elemnet?.consultant?.username}</td>
							<td>
								{elemnet.callDirection ||
									(elemnet.type === 'incoming' ? 'inbound' : 'outbound')}
							</td>
							<td>{elemnet?.productName || ''}</td>
							<td>{formatToDateTimeFormaterTemplate(elemnet.created_at)}</td>
							<td>{elemnet.type === 'incoming' ? elemnet.from : elemnet.to}</td>
							<td>{elemnet?.contact?.full_name || '------'}</td>
							<td>
								<IconsWrapper>
									<Icon
										name='ear-listen'
										style={{ cursor: 'pointer', color: Colors.red }}
										onClick={(e) => handleGetRecording(e, elemnet)}
									/>
									<ActionButton
										disabled={elemnet.listeningScoring}
										onClick={(e) => handleGeToRate(e, elemnet)}
										style={{
											border: 'none',
											margin: '0',
											padding: '0',
											background: 'transparent',
										}}
									>
										<Icon
											name='check'
											style={{ cursor: 'pointer' }}
										/>
									</ActionButton>
									<ActionButton
										disabled={!elemnet.listeningScoring}
										onClick={(e) => setShowTicket(elemnet.listeningScoring)}
										style={{
											border: 'none',
											margin: '0',
											padding: '0',
											background: 'transparent',
										}}
									>
										<Icon
											name='plus'
											style={{ cursor: 'pointer' }}
										/>
									</ActionButton>
									<ActionButton
										onClick={() => handleGetTranscription(elemnet)}
										style={{
											border: 'none',
											margin: '0',
											padding: '0',
											background: 'transparent',
										}}
									>
										<Icon
											name='scroll'
											style={{ cursor: 'pointer', color: Colors.darkBlue }}
										/>
									</ActionButton>
								</IconsWrapper>
							</td>
						</tr>
					))}
			</tbody>
		</table>
	);
};

export default CurrentWeekScoreTable;
